export enum RequestStatus {
  Ok = 'Ok',
  Error = 'Error',
}

export const isInitialRequest = (status?: RequestStatus) =>
  status === undefined;
